// @flow

import typeToReducer from 'type-to-reducer'
import { normalize } from 'normalizr'

import type { Country } from '@alphaott/api-client/types/countries'
import type { CountriesNormalize } from '@alphaott/common-types/normalized'

import { isValidTTL, calculateExpires } from '@alphaott/app-main/selectors'
import { countriesListSchema } from '@alphaott/common-utils/utils/schemas/countries'

import { defaultToEmptyObject } from '@alphaott/common-utils/utils/help'
import { FETCH_MOVIE_COUNTRIES_TYPE } from '../../actions/countries'

export type MovieCountriesState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: Array<Country>,
  +entities: CountriesNormalize,
  +expires: ?number,
}

const initialState: MovieCountriesState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
  entities: {},
  expires: null,
}

const movieCountries = typeToReducer(
  {
    [FETCH_MOVIE_COUNTRIES_TYPE]: {
      LOADING: (state): MovieCountriesState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): MovieCountriesState => {
        const {
          payload,
          meta: { ttl },
        } = action
        const { entities } = normalize(payload.data, countriesListSchema)
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          data: payload.data,
          entities: defaultToEmptyObject(entities.countries),
          ...(isValidTTL(ttl) && { expires: calculateExpires(ttl) }),
        }
      },

      ERROR: (state, action): MovieCountriesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
        expires: null,
      }),
    },
  },
  initialState,
)

export { movieCountries }
